export default __webpack_public_path__ + "fonts/detached.svg";